<template>
  <div>
    <div class="flex items-center space-x-4">
      <h2>{{ isEditing ? "Editar" : "Crear" }} Rol</h2>
    </div>

    <div
      v-if="!loading"
      class="card mt-2"
    >
      <form v-if="permissions" @submit.prevent="save">
        <section-header title="Información del Rol" />

        <div class="flex flex-col w-full">
          <label for="name">Rol</label>
          <input id="name" type="text" v-model="form.name" />
          <validation-errors :errors="errorFor('name')"></validation-errors>
        </div>

        <section-header title="Permisos" />
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          <div
            v-for="permission in permissions"
            :key="permission.id"
            class="flex items-center mt-2 mr-8"
          >
            <input
              id="terms"
              type="checkbox"
              class="h-5 w-5"
              v-model="form.permissionIds[permission.id]"
            />
            <span for="terms" class="ml-2">{{ permission.display_name }}</span>
          </div>
        </div>
        <validation-errors
          :errors="errorFor('permissions')"
        ></validation-errors>

        <primary-button type="submit" class="mt-10 mx-0" :loading="loadingForm"
          >{{ isEditing ? "Guardar" : "Crear" }}
        </primary-button>
      </form>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import validationErrors from "@/mixins/validationErrors";
import { is422 } from "@/utils/response";
export default {
  name: "Role Form",

  data() {
    return {
      form: {
        name: "",
        permissionIds: {},
      },
      loading: false,
      loadingForm: false,
      isEditing: false,
      permissions: null,
    };
  },

  created() {
    this.$store.commit("setSelectedTab", "roles");

    this.loadPermissions();

    if (this.$route.params.id) {
      this.isEditing = true;
      this.loadRole();
    }
  },

  mixins: [validationErrors],

  methods: {
    async loadPermissions() {
      this.loading = true;

      try {
        this.permissions = await api.roles.getPermissions();
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    togglePermission(event, permissionId) {
      if (event.target.checked) {
        this.form.permissionIds.push(permissionId);
      } else {
        this.form.permissionIds = this.form.permissionIds.filter(
          (id) => id !== permissionId
        );
      }
    },

    async loadRole() {
      this.loading = true;

      try {
        let role = await api.roles.getById(this.$route.params.id);
        role.permissionIds = {};
        role.permissions.forEach(permission => {
          role.permissionIds[permission.id] = true
        });
        delete role.permissions;

        this.form = await JSON.parse(JSON.stringify(role));
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    save() {
      if (!this.validateForm()) {
        this.$store.dispatch(
          "errorSnack",
          "Favor de llenar todos los campos correctamente."
        );
        return;
      }

      if (!this.isEditing) {
        this.createRole();
      } else {
        this.updateRole();
      }
    },

    validateForm() {
      this.errors = {};

      if (!this.form.name) {
        this.errors["name"] = ["Campo requerido"];
      }

      if (!Object.values(this.form.permissionIds).includes(true)) {
        this.errors["permissions"] = ["Debes agregar al menos un permiso"];
      }

      return Object.keys(this.errors).length === 0;
    },

    async createRole() {
      this.loadingForm = true;

      try {
        const response = await api.roles.create(this.form);
        this.$store.dispatch("successSnack", response.message);
        this.$router.push({ name: "rolesIndex" });
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingForm = false;
    },

    async updateRole() {
      this.loadingForm = true;

      try {
        const response = await api.roles.update(
          this.$route.params.id,
          this.form
        );
        this.$store.dispatch("successSnack", response.message);
        this.$router.push({ name: "rolesIndex" });
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingForm = false;
    },
  },
};
</script>